import React from 'react';
import type { IconProps } from '../types';

export const IconOrders: React.FC<IconProps> = ({ size = 20, className = '', color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    {/* Orders icon - list with checkboxes/status indicators */}
    <rect x="2" y="3" width="16" height="14" rx="1" stroke={color} strokeWidth="1.5"/>
    <line x1="5" y1="7" x2="9" y2="7" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
    <line x1="5" y1="10" x2="11" y2="10" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
    <line x1="5" y1="13" x2="8" y2="13" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
    {/* Status dots */}
    <circle cx="14.5" cy="7" r="1.5" fill={color} fillOpacity="0.3"/>
    <circle cx="14.5" cy="10" r="1.5" fill={color} fillOpacity="0.6"/>
    <circle cx="14.5" cy="13" r="1.5" fill={color}/>
  </svg>
);
